import { Action } from 'redux';
import { buffers, Task } from 'redux-saga';
import { ActionPattern } from 'redux-saga/effects';
import { actionChannel, cancel, delay, fork, take } from 'typed-redux-saga';

export function* takeLatestThrottled<A extends Action>(
    ms: number,
    pattern: ActionPattern<A>,
    worker: (action: A) => Generator
) {
    return yield* fork(function* () {
        const ac = yield* actionChannel(pattern, buffers.sliding<A>(1));
        let task: Task | null = null;

        while (true) {
            const action = yield* take(ac);

            if (task) {
                yield* cancel(task);
            }

            task = yield* fork(worker, action);

            yield* delay(ms);
        }
    });
}
